module.exports = __webpack_public_path__ + "img/user-4@2x.156eab3.png";